<button class="chevron" [class.button-open]="!expanded" [class.button-close]="expanded" (click)="handleClick()">
  <i class="fa fa-chevron-right animate" [ngClass]="expanded ? 'opening' : 'closing'" ></i>
</button>
